import { useEffect, useRef } from 'react';

const pageNames = {
  home: 'Marketplace Home',
  homepage2: 'Homepage 2',
  deals: 'Deals & Promotions',
  search: 'Search',
  product: 'Product',
  vendor: 'Vendor',
  category: 'Category',
};

export default function SiteAnalyticsTracker({ backendUrl, currentPage }) {
  const lastSent = useRef('');
  useEffect(() => {
    if (!backendUrl || !currentPage) return;
    const path = `${window.location.pathname}${window.location.hash || ''}`;
    const key = `${currentPage}|${path}`;
    if (lastSent.current === key) return;
    lastSent.current = key;
    fetch(`${backendUrl}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type: 'page_view', page_path: path || '/', page_name: pageNames[currentPage] || currentPage, current_page: currentPage }),
      keepalive: true,
    }).catch(() => {});
  }, [backendUrl, currentPage]);
  return null;
}
